import { useEffect } from 'react';
import { MapContainer, Marker, Polyline, TileLayer, Tooltip, useMap } from 'react-leaflet';
import L from 'leaflet';
import { formatInTimeZone } from 'date-fns-tz';
import 'leaflet/dist/leaflet.css';

const defaultCenter = [-6.149770617808631, 106.18218026749454];

const officerIcon = L.icon({
  iconUrl: '/assets/map/officer.png',
  iconSize: [40, 40],
  iconAnchor: [20, 40],
});

function MapViewport({ positions }) {
  const map = useMap();

  useEffect(() => {
    if (positions.length > 1) {
      map.fitBounds(positions, { padding: [32, 32] });
    } else if (positions.length === 1) {
      map.setView(positions[0], 14);
    }
  }, [map, positions]);

  return null;
}

export default function FreeTrackingMap({ points }) {
  const positions = points.map(({ koordinat }) => [koordinat.lat, koordinat.lng]);

  return (
    <MapContainer center={defaultCenter} zoom={12} style={{ width: '100%', height: 500 }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <MapViewport positions={positions} />
      {positions.length > 1 && <Polyline positions={positions} pathOptions={{ color: '#2065d1', weight: 4 }} />}
      {points.map((item, index) => (
        <Marker key={`${item._id || item.tanggal}-${index}`} position={positions[index]} icon={officerIcon}>
          <Tooltip direction="top" offset={[0, -36]}>
            {`P${index + 1} - ${item.dtd
              ? `${item.rumpun?.nama || 'Unknown'} - ${item.anggota?.nama || 'Unknown'}`
              : item.rumpun?.nama || 'Unknown'} - ${formatInTimeZone(new Date(item.tanggal), 'UTC', 'HH:mm')}`}
          </Tooltip>
        </Marker>
      ))}
    </MapContainer>
  );
}
